"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuestDynamoMapper = void 0;
const dynamodb_mapper_1 = require("../dynamodb-mapper");
const guest_json_1 = require("./guest-json");
exports.GuestDynamoMapper = (0, dynamodb_mapper_1.createDynamoMapper)('Guest', guest_json_1.GuestJsonMapper);
